import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import classNames from 'classnames';
import Translate from '../../../components/translate/Translate';
import React from 'react';
import {SurveyModalProps} from '../SurveyModal.component';

@observer
export class SurveyModalToolbar extends TechseeBaseComponent<SurveyModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        const isFormValid = ctrl.isFormValid;
        const dir = ctrl.dir;

        return (
            <div className='sub-modal-footer'>
                <button
                    className={classNames('btn', 'cancel', {left: dir === 'rtl'})}
                    type='button'
                    onClick={ctrl.close}>
                    <Translate text='DASHBOARD.SURVEY.CANCEL' />
                </button>
                <button
                    className={classNames('btn', 'submit', {left: dir === 'rtl'})}
                    type='button'
                    onClick={ctrl.submit}
                    disabled={!isFormValid}>
                    {dir === 'rtl' && <img className='left' src={ctrl.requireImage('chevron-left-blue.png')} alt='' />}
                    <Translate text='DASHBOARD.SURVEY.SUBMIT' />
                    {dir === 'ltr' && <img src={ctrl.requireImage('chevron-right-blue.png')} alt='' />}
                </button>
            </div>
        );
    }
}
